<div class="modal-header">
  <h5 class="modal-title d-flex align-items-center">
    <i class="ri-group-3-line me-1 font-20 text-primary"></i>{{teamForm.value.id ? 'Update' : 'Add'}} Team
  </h5>
  <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" id="close"
    (click)="activeModal.close('Close')" routerLink="/project-pilot/teams"></button>
</div>
<div class="modal-body">
  <form class="row g-3" [formGroup]="teamForm" (ngSubmit)="saveTeam(inProgress)">
    <div class="col-md-8">
      <label for="name" class="form-label">Name <b class="text-secondary">*</b></label>
      <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
            class='bx bxs-purchase-tag'></i></span>
        <input type="text" class="form-control ps-1" id="name" placeholder="Enter team name"
          [ngClass]="{'is-invalid': submitted && t.name.errors}" formControlName="name" ngbAutofocus
          autocomplete="off" />
        <div class="invalid-feedback" *ngIf="submitted && t.name.errors">
          <span *ngIf="t.name.errors.required">Please provide a valid name.</span>
          <span *ngIf="t.name.errors.pattern">Team name must be 1-250 chars</span>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <label for="code" class="form-label">Code</label>
      <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
            class='bx bx-barcode-reader'></i></span>
        <input type="text" class="form-control ps-1" id="code" placeholder="Code" formControlName="code"
          autocomplete="off" readonly />
      </div>
    </div>
    <div class="col-md-8">
      <label for="description" class="form-label">Description</label>
      <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
            class='bx bx-clipboard'></i></span>
        <textarea type="text" class="form-control ps-1" id="description" placeholder="Describe the team details."
          rows="1" [ngClass]="{'is-invalid': submitted && t.description.errors}" formControlName="description"
          autocomplete="off"></textarea>
        <div class="invalid-feedback" *ngIf="submitted && t.description.errors">
          <span *ngIf="t.description.errors.required">Please provide a valid description.</span>
          <span *ngIf="t.description.errors.pattern">Description must be 1-250 chars</span>
        </div>
      </div>
    </div>
    <div class="col-md-auto">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="disabled" formControlName="disabled">
        <label class="form-check-label" for="disabled">Disabled</label>
      </div>
    </div>
    <div class="modal-footer border-0">
      <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}"
        id="save-btn">
        <ng-container *ngIf="inProgress?.value=='true'">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{teamForm.value.id?'Updating...':'Saving...'}}
        </ng-container>
        <ng-container *ngIf="inProgress?.value!='true'">
          <i class="bx bx-save"></i>{{teamForm.value.id?'Save Changes':'Save'}}
        </ng-container>
      </button>
    </div>
  </form>
  <div class="dotted-divider" *ngIf="teamForm.value.id"></div>
  <ng-container *ngIf="teamForm.value.id">
    <h5 class="card-title mt-3">
      <i class="bx bx-group me-1 text-primary"></i>Members
    </h5>
    <div class="row d-flex justify-content-between align-items-center">
      <div class="col-sm-12 col-md-5 col-lg-8 me-auto">
        <div class="input-group" *ngIf="!isNewUser">
          <span class="input-group-text bg-primary" ngbTooltip="Search teams by name." placement="top" container="body">
            <i class="bx bx-search-alt"></i>
          </span>
          <input type="text" class="form-control border-start-0" id="search" placeholder="Search..." autocomplete="off"
            [(ngModel)]="searchKeyword" [ngModelOptions]="{standalone: true}">
        </div>
        <div class="input-group" *ngIf="isNewUser">
          <span class="input-group-text bg-primary" id="team-selection" ngbTooltip="Search teams by name."
            placement="top" container="body">
            <i class="bx bx-search-alt"></i>
          </span>
          <ng-select #ngTeamSelect id="ng-member" class="form-control rcx-ng-select" placeholder="Select Members"
            multiple="true" [(ngModel)]="selectedMemberIds" [ngModelOptions]="{standalone: true}"
            [ngClass]="{'is-invalid': isMemberSelected && selectedMemberIds.length===0}">
            <ng-option *ngFor="let employee of employees" [value]="employee.employeeId"
              [disabled]="isEmployeeDisabled(employee.employeeId)">
              <img class="avatar-sm" [src]="employee.avatar||'assets/images/avatar.png'" alt="avatar">
              {{employee.employeeName}}
            </ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="isMemberSubmitted && selectedMemberIds.length===0">
            <span>Please select a member.</span>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-auto align-self-center d-flex">
        <!-- <button *ngIf="isNewUser" type="button" class="btn btn-primary btn-sm me-2" id="close-btn"
          (click)="isNewUser=false; cancel()">
          <i class="bx bx-x"></i>Cancel
        </button> -->
        <button type="button" class="btn btn-secondary btn-sm d-flex align-items-center justify-content-center"
          #isSaving (click)="addMembers(isSaving)" [ngClass]="{'no-event': isSaving?.value == 'true'}" id="save-btn">
          <ng-container *ngIf="isSaving?.value == 'true'">
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          </ng-container>
          <ng-container *ngIf="isSaving?.value != 'true'">
            <i class="bx bx-plus"></i> Add
          </ng-container>
        </button>
      </div>
    </div>
    <div class="rcx-table">
      <table class="table" id="table">
        <thead id="table-thead">
          <tr class="bg-light">
            <th scope="col" width="300">Member</th>
            <th scope="col" width="300">Role</th>
            <th scope="col" width="160" class="text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let member of members | search : 'employeeName' : searchKeyword; let i=index">
            <td>
              <img class="avatar-sm" [src]="member.employeeAvatar||'assets/images/avatar.png'" alt="avatar">
              {{member.employeeName}}
            </td>
            <!-- <td class="col-lg-3 px-0" *ngIf="editingIndex !== i" (click)="enableDropdown(i, member.roleId)">
              {{ member.teamRoleName }}
            </td> -->
            <td class="col-lg-3 px-0">
              <ng-container *ngIf="editingIndex !== i; else roleDropdown">
                <span class="d-block w-100" (click)="enableDropdown(i, member.roleId)">
                  {{ member.teamRoleName }}
                </span>
              </ng-container>
              <ng-template #roleDropdown>
                <ng-select 
                  class="form-control rcx-ng-select sm w-100"
                  [ngModelOptions]="{standalone: true}"
                  [(ngModel)]="selectedRole"
                  [items]="roles"
                  bindLabel="name"
                  bindValue="id"
                  placeholder="Select Role"
                  [clearable]="false"
                  [closeOnSelect]="true"
                  [openOnEnter]="true"
                  (change)="updateRole(member, $event)"
                  (blur)="cancelEdit(i)">
                </ng-select>
              </ng-template>
            </td>            
            <td class="text-end align-middle">
              <div class="d-inline-flex align-items-center gap-2">
                <div class="form-check form-switch mb-0">
                  <input class="form-check-input custom-switch" type="checkbox" [id]="'toggle-' + i"
                    [checked]="!member.disabled" (change)="toggleTeamMemberStatus(member)">
                </div>
                <i *ngIf="!member.isDeleteInProgress" class="bx bx-trash alert-secondary" id="update-btn"
                  [ngbTooltip]="'Delete'" (click)="deleteMember(member, i)">
                </i>
                <div *ngIf="member.isDeleteInProgress" role="status"
                  class="spinner-border spinner-border-sm text-danger">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </td>

          </tr>
          <tr class="no-data">
            <ng-container *ngIf="isLoading; else noDataTemplate">
              <td colspan="5">Fetching data, please wait...</td>
            </ng-container>
            <ng-template #noDataTemplate>
              <ng-container *ngIf="!isLoading && members?.length === 0">
                <td colspan="5">No members were found.</td>
              </ng-container>
              <ng-template #noSearchResults>
                <td colspan="5"
                  *ngIf="searchKeyword && (members | search : 'employeeName' : searchKeyword).length == 0">
                  No members were found for the search results.
                </td>
              </ng-template>
            </ng-template>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>